// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/pocket-man.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "._3qs8FxoWx{display:flex;flex-direction:column;width:100%;height:100%;position:relative;background-color:white}._1tSXmHOkx{height:221px;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-repeat:no-repeat;background-attachment:fixed;background-color:#0b61cd;background-position:-100px 0px}@media (min-width: 768px){._1tSXmHOkx{background-position:center 0px}}._7sD7OSOHx{display:flex;flex-direction:column;align-items:center}._9bUWq6c9x{padding:32px 40px;text-align:center}@media (min-width: 768px){._9bUWq6c9x{padding:60px 32px}}._5ZoJLJSCx{margin:8px;width:220px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"top-container": "_3qs8FxoWx",
	"topContainer": "_3qs8FxoWx",
	"image-container": "_1tSXmHOkx",
	"imageContainer": "_1tSXmHOkx",
	"content-container": "_7sD7OSOHx",
	"contentContainer": "_7sD7OSOHx",
	"title": "_9bUWq6c9x",
	"button": "_5ZoJLJSCx"
};
module.exports = exports;
